import * as React from "react";
import { Context } from "./_context";
export const NavigationCloseIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.823 2.055a.25.25 0 0 1 .354 0l1.767 1.768a.25.25 0 0 1 0 .354L14.121 12l7.823 7.823a.25.25 0 0 1 0 .354l-1.767 1.767a.25.25 0 0 1-.354 0L12 14.121l-7.823 7.823a.25.25 0 0 1-.354 0l-1.768-1.767a.25.25 0 0 1 0-.354L9.88 12 2.055 4.177a.25.25 0 0 1 0-.354l1.768-1.768a.25.25 0 0 1 .354 0L12 9.88l7.823-7.824Z", fill: "currentColor" }));
  return iconset[size];
};
NavigationCloseIcon.iconId = "Fh4cHB";
